import { memo } from 'react';

function RouteStopMarker(props) {
  const shiftLeft = (props.stopNo && props.stopNo < 10) ? 0: -3;
  return (
            <svg width={props.dimension} height={props.dimension} viewBox="0 0 23 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" >
        {/* Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch */}

      <desc>Created with Sketch.</desc>
      <defs>
        <radialGradient cx="50%" cy="0%" fx="50%" fy="0%" r="100%" id="radialGradient-1">
          <stop stopColor="#0CD3C4" offset="0%" />
          <stop stopColor="#05A792" offset="100%" />
        </radialGradient>
      </defs>
      <g id="Map-interactions" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Group-30" transform="translate(1.000000, 1.000000)">
          <circle id="Oval" stroke={props.border} fill={props.backgroundColor} fillRule="nonzero" cx="10.5" cy="10.5" r="10.5" />
          <circle id="Oval" stroke={props.border} fill={props.backgroundColor} fillRule="nonzero" cx="10.5" cy="10.5" r="10.5" />
          <text id={8} fontFamily="OpenSans-SemiBold, Open Sans" fontSize={10} fontWeight={500} fill={props.textColor}>
            <tspan x={8+shiftLeft} y={14}>{props.stopNo}</tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default memo(RouteStopMarker);